var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"safe-manager"}},[_c('div',{staticClass:"wrapper"},[_c('img',{staticClass:"security_img",attrs:{"src":'https://cdn.zxzx119.com/zxzx-h5/other/security02.jpg?v='+Date.now(),"alt":"","srcset":""}})])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-d600919a","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/view/activity/security.vue
// module id = null
// module chunks = 